import React from "react";
import { Outlet, useParams } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";

const Layout = () => {
  const { lang } = useParams();
  return (
    <div data-testid="app-shell" data-lang={lang}>
      <Header />
      <main data-testid="main-content">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};

export default Layout;
